import React from "react";
import { Slide } from "react-reveal";
import d1 from "../../assets/images/nexus/1.png";
import d2 from "../../assets/images/nexus/2.png";
import d3 from "../../assets/images/nexus/3.png";
import d4 from "../../assets/images/nexus/4.png";
import d5 from "../../assets/images/nexus/5.png";
import d6 from "../../assets/images/nexus/6.png";
import d7 from "../../assets/images/nexus/7.png";
import d8 from "../../assets/images/nexus/8.png";
import d9 from "../../assets/images/nexus/9.png";
import d10 from "../../assets/images/nexus/10.png";
import d11 from "../../assets/images/nexus/11.png";
import v1 from "../../assets/images/nexus/v1.mp4";
import GallerySlideCard from "../reusables/GallerySlideCard";
import GallerySlideCardVideo from "../reusables/GallerySlideCardVideo";

const OurWork = () => {
  return (
    <section className="section section-spacing-50">
      <div className="large">
        <div className="section-content">
          <div className="width-600 margin-auto center">
            <Slide top>
              <div className="section-head">
                <h2 className="section-title dark">SEE US AT WORK</h2>
              </div>
            </Slide>
          </div>
          <div className="section-body section-spacing-20">
            <div className="gallery-slider-container slider-container slider">
              <ul className="slide-track slider-items-wrap trustedby-items-wrapper">
                <GallerySlideCard img={d1} />
                <GallerySlideCard img={d2} />
                <GallerySlideCard img={d3} />
                <GallerySlideCard img={d4} />
                <GallerySlideCard img={d5} />
                <GallerySlideCard img={d6} />
                <GallerySlideCard img={d7} />
                <GallerySlideCard img={d8} />
                <GallerySlideCard img={d9} />
                <GallerySlideCard img={d10} />
                <GallerySlideCard img={d11} />
              </ul>
            </div>
          </div>
          <div className="section-footer buttons-container flex justify-center">
            <a
              href="/portfolio"
              className="button padding-16 boldTitle dark-bg white"
            >
              View Our Portfolio
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurWork;
